"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileContract = compileContract;
const web_solc_1 = require("@usecannon/web-solc");
async function compileContract(contractName, sourceCode, evmVersion = 'paris', compilerVersion = '0.8.27') {
    const { compile, stopWorker } = await (0, web_solc_1.fetchSolc)(compilerVersion);
    const sourceName = `${contractName}.sol`;
    const input = {
        language: 'Solidity',
        sources: {
            [sourceName]: {
                content: sourceCode,
            },
        },
        settings: {
            outputSelection: {
                '*': { '*': ['*'] },
            },
            evmVersion,
        },
    };
    try {
        const output = await compile(input);
        if (output.errors) {
            throw new Error([
                `There was an error when compiling "${contractName}".`,
                ...output.errors.map((err) => err.message),
            ].join(' '));
        }
        const info = output.contracts[sourceName][contractName];
        const metadata = JSON.parse(info.metadata);
        const result = {
            contractName,
            sourceName,
            abi: info.abi,
            metadata: info.metadata,
            solcVersion: metadata.compiler.version,
            assembly: info.evm.assembly,
            bytecode: info.evm.bytecode.object,
            deployedBytecode: info.evm.deployedBytecode.object,
            gasEstimates: info.evm.gasEstimates,
        };
        return { input, output: result };
    }
    finally {
        stopWorker();
    }
}
//# sourceMappingURL=compile.js.map